function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 15.1V18.1H8.9L14.8 12.2L11.8 9.20001L6 15.1ZM13.2 12.2L8.5 16.9H7.2V15.5L11.8 10.8L13.2 12.2Z",
  fill: "#00AAFF"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1 6L12.8 8.3L15.8 11.3L18.1 8.9L15.1 6ZM15.7 9.6L14.5 8.3L15.1 7.7L16.4 9L15.7 9.6Z",
  fill: "#00AAFF"
});
const SvgEditIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit-icon.4ab30996.svg";
export { ForwardRef as ReactComponent };